import React from 'react'

import AddPatientDefaultLayout from 'presentation/doctor/layouts/AddPatientDefault'

const AddPatientDefault = () => <AddPatientDefaultLayout />

export default AddPatientDefault
